import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { DollarSign } from "lucide-react";

const val = (v) => (v === undefined || v === null ? "" : String(v));

export const UserPricingButton = ({ u, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [run, setRun] = useState(val(u.custom_run_price));
  const [bulk, setBulk] = useState(val(u.custom_bulk_price));
  const [deity, setDeity] = useState(val(u.custom_deity_price));
  const [contact, setContact] = useState(val(u.custom_contact_price));
  const save = async () => {
    const toNum = (s) => (s.trim() === "" ? -1 : Number(s));
    const r = toNum(run), b = toNum(bulk), d = toNum(deity), c = toNum(contact);
    if ([r, b, d, c].some((x) => x !== -1 && (isNaN(x) || x < 0))) { toast.error("Prices must be 0 or more (leave blank for the global price)"); return; }
    try { await api.patch(`/admin/users/${u.id}`, { custom_run_price: r, custom_bulk_price: b, custom_deity_price: d, custom_contact_price: c }); toast.success("Pricing saved"); setOpen(false); onSaved?.(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const custom = u.custom_run_price != null || u.custom_bulk_price != null || u.custom_deity_price != null || u.custom_contact_price != null;
  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => { setRun(val(u.custom_run_price)); setBulk(val(u.custom_bulk_price)); setDeity(val(u.custom_deity_price)); setContact(val(u.custom_contact_price)); setOpen(true); }} data-testid={`pricing-${u.id}`}
        className={custom ? "text-amber-700" : ""}><DollarSign className="mr-1 h-3.5 w-3.5" /> {custom ? "Custom pricing" : "Pricing"}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="pricing-dialog">
          <DialogHeader>
            <DialogTitle>Pricing for {u.first_name} {u.last_name}</DialogTitle>
            <DialogDescription>Leave a field blank to use the global price from Settings.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div><Label>Price per lead run ($)</Label><Input type="number" min="0" step="0.01" value={run} onChange={(e) => setRun(e.target.value)} placeholder="Global price" data-testid="pricing-run-input" /></div>
            <div><Label>Contact all price ($)</Label><Input type="number" min="0" step="0.01" value={bulk} onChange={(e) => setBulk(e.target.value)} placeholder="Global price" data-testid="pricing-bulk-input" /></div>
            <div><Label>AI Autopilot Mode price per month ($)</Label><Input type="number" min="0" step="0.01" value={deity} onChange={(e) => setDeity(e.target.value)} placeholder="Global price" data-testid="pricing-deity-input" /></div>
            <div><Label>Individual contact price ($)</Label><Input type="number" min="0" step="0.01" value={contact} onChange={(e) => setContact(e.target.value)} placeholder="Global price" data-testid="pricing-contact-input" /></div>
          </div>
          <DialogFooter><Button onClick={save} className="bg-slate-900 hover:bg-slate-800" data-testid="pricing-save-btn">Save pricing</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
